<template>
  <div class="partner-hospital-binding-doctor">
    <!-- 文本分段渲染（普通文本 + 电话） -->
    <span v-for="(item, index) in textList" :key="index">
      <!-- 电话号码 -->
      <span v-if="item.type === 'phone'" class="phone-text">
        {{ item.text }}
      </span>

      <!-- 普通文本 -->
      <span v-else>
        {{ item.text }}
      </span>
    </span>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { defineProps } from 'vue'
const props = defineProps({
  msg: {
    type: Object,
    default: () => ({})
  }
})
// 将字符串拆分为结构化数组
const textList = computed(() => {
  const content = props?.msg?.msg || ''
  if (!content) return []
  //  正则说明：
  //  (\*95148\*) -> 捕获 *95148*
  //  split 会保留捕获内容，方便后续识别
  const arr = content.split(/(\*95148\*)/g)
  // 将字符串数组 -> 结构化数组
  const list = arr.map(item => {
    // 命中电话标记
    if (item === '*95148*') {
      return {
        type: 'phone',
        text: '95148' // 去掉 * 只展示数字
      }
    }
    // 普通文本
    return {
      type: 'text',
      text: item
    }
  })
  return list
})
</script>

<style scoped lang="scss">
.partner-hospital-binding-doctor {
  background: #e8e8e9;
  padding: 12px 16px;
  list-style: none;
  text-align: left;
  display: inline-block;
  word-break: break-all;
  margin: 0;
  font-size: 14px;
  color: #333333;
  border-radius: 2px 8px 8px 8px;
  overflow: hidden;
}
.phone-text {
  color: #4c6ee0;
  font-weight: 500;
  cursor: pointer;
}
</style>
